import './DAcCreateAccount.css';
import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import Cookies from 'js-cookie';
import { useLocation } from 'react-router-dom';
import { SitecoreContextReactContext } from '../../utils/SitecoreContextReactContext';
import { get, getDictionaryItem } from '../../utils';
import ComponentsWrapper from '../atoms/ComponentsWrapper';
import DacLoginForm from './components/DacLoginForm';
import DacRegisterForm from './components/DacRegisterForm';

// import checkboxTick from '../../resources/icons/check-box-white.svg';

import IconCreateAccount from './components/icon/create';
import IconLoginAccount from './components/icon/login';
import InjectHTML from './components/InjectHTML';
const FIELDS_PARAMS = {
  usernameMaxLength: 20,
  usernameMinLength: 3,
  firstnameMaxLength: 50,
  firstnameMinLength: 2,
  lastnameMaxLength: 50,
  lastnameMinLength: 2,
  otpRequiredLength: 6
};
const DAcCreateAccount = props => {
  const sitecoreContext = React.useContext(SitecoreContextReactContext);
  const rtl = Boolean(sitecoreContext && sitecoreContext.rtl);
  const {
    search
  } = useLocation();
  const type = new URLSearchParams(search).get('type');
  const history = useHistory();
  const {
    fields,
    params
  } = props;
  const {
    data: {
      configuration,
      dictionary,
      settings
    }
  } = fields;
  const apiKey = get(settings, 'apiKey.jss.value');
  const apiUrl = get(settings, 'apiUrl.jss.value');
  const showCreateAccountTab = get(configuration, 'showCreateAccountTab.jss.value', false);
  const [activeTabItem, setActiveTabItem] = useState(type && type === 'login' ? 'login-account' : 'create-account');
  const changeActiveTab = (event, tabKey) => {
    event.preventDefault();
    if (tabKey !== activeTabItem) {
      setActiveTabItem(tabKey);
    }
  };
  useEffect(() => {
    const tokken = Cookies.get('token');
    if (tokken) {
      history.push(get(configuration, 'loginButton.jss.value.href'));
    }
  }, []);
  return /*#__PURE__*/React.createElement(StyledWrapper, {
    rtl: rtl
  }, /*#__PURE__*/React.createElement("div", {
    className: "dac-login"
  }, showCreateAccountTab ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "row"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col-12 col-md-6"
  }, ' ', /*#__PURE__*/React.createElement("h1", {
    className: "dac-login__title"
  }, get(configuration, 'accountTitle.jss.value', '')), /*#__PURE__*/React.createElement("p", {
    className: "dac-login__description"
  }, get(configuration, 'createAccountDescription.jss.value', ''))), /*#__PURE__*/React.createElement("div", {
    className: "d-none d-md-block col-12 col-md-6 col-xl-4 ml-xl-auto"
  }, /*#__PURE__*/React.createElement("div", {
    className: "dac-login__image"
  }, /*#__PURE__*/React.createElement(InjectHTML, {
    htmlString: get(configuration, 'dACIconCode.value', '')
  })))), /*#__PURE__*/React.createElement("div", {
    className: "dac-login__form-wrap dac-login__form-wrap--tabs"
  }, /*#__PURE__*/React.createElement("div", {
    className: "tabs-top"
  }, /*#__PURE__*/React.createElement("div", {
    className: "tabs-group"
  }, /*#__PURE__*/React.createElement("div", {
    className: "tabs-heading"
  }, /*#__PURE__*/React.createElement("ul", {
    className: "t__list"
  }, /*#__PURE__*/React.createElement("li", {
    className: `t__item ${'create-account' === activeTabItem ? 'active' : ''}`,
    "data-tab": "1",
    onClick: e => {
      changeActiveTab(e, 'create-account');
    },
    tabIndex: activeTabItem === 'create-account' ? -1 : 0,
    onKeyPress: e => {
      if (e.which === 13 || e.which === 32) {
        e.preventDefault();
        changeActiveTab(e, 'create-account');
      }
    }
  }, /*#__PURE__*/React.createElement("span", {
    className: "t__item-icon"
  }, /*#__PURE__*/React.createElement(IconCreateAccount, null)), getDictionaryItem(dictionary, 'createAccount')), /*#__PURE__*/React.createElement("li", {
    className: `t__item ${'login-account' === activeTabItem ? 'active' : ''}`,
    "data-tab": "2",
    onClick: e => {
      changeActiveTab(e, 'login-account');
    },
    tabIndex: activeTabItem === 'login-account' ? -1 : 0,
    onKeyPress: e => {
      if (e.which === 13 || e.which === 32) {
        e.preventDefault();
        changeActiveTab(e, 'login-account');
      }
    }
  }, /*#__PURE__*/React.createElement("span", {
    className: "t__item-icon"
  }, /*#__PURE__*/React.createElement(IconLoginAccount, null)), getDictionaryItem(dictionary, 'AlreadyHaveGdrfaAccount')))), /*#__PURE__*/React.createElement("div", {
    className: "t-body"
  }, /*#__PURE__*/React.createElement("div", {
    className: activeTabItem === 'create-account' ? 't-content active' : 't-content'
  }, /*#__PURE__*/React.createElement(DacRegisterForm, {
    dictionary: dictionary,
    configuration: configuration,
    apiConfig: {
      apiKey,
      apiUrl
    },
    fieldsParams: FIELDS_PARAMS
  })), /*#__PURE__*/React.createElement("div", {
    className: activeTabItem === 'login-account' ? 't-content active' : 't-content'
  }, /*#__PURE__*/React.createElement(DacLoginForm, {
    dictionary: dictionary,
    configuration: configuration,
    apiConfig: {
      apiKey,
      apiUrl
    },
    fieldsParams: FIELDS_PARAMS
  }))))))) : /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("h1", {
    className: "dac-login__title"
  }, "Login to GDRFA account"), /*#__PURE__*/React.createElement("p", {
    className: "dac-login__description"
  }, get(configuration, 'loginDescription.jss.value', '')), /*#__PURE__*/React.createElement("div", {
    className: "dac-login__form-wrap"
  }, /*#__PURE__*/React.createElement(DacLoginForm, {
    dictionary: dictionary,
    configuration: configuration,
    apiConfig: {
      apiKey,
      apiUrl
    },
    fieldsParams: FIELDS_PARAMS
  })))));
};
const StyledWrapper = _ref => {
  let {
    children,
    rtl,
    anchorUrlParameter
  } = _ref;
  return /*#__PURE__*/React.createElement(ComponentsWrapper, {
    anchorUrlParameter: anchorUrlParameter,
    className: `${commonStyles} ${rtl ? rtlStyles : ltrStyles}`
  }, children);
};
export default DAcCreateAccount;
const commonStyles = "c198hgnz";
const ltrStyles = "l5o5bks";
const rtlStyles = "r1w3ys4a";